"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ListBody = ListBody;
exports.ListButton = ListButton;
exports.ListContainer = ListContainer;
exports.ListFoot = ListFoot;
exports.ListHead = ListHead;
exports.ListHeadSort = ListHeadSort;
exports.default = exports.ListStack = void 0;
var React = _interopRequireWildcard(require("react"));
var _utils = require("./utils");
var _PageScroll = _interopRequireDefault(require("./PageScroll"));
var _Wait = _interopRequireDefault(require("./Wait"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
// ----- COMPONENT

var List = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement("div", {
    ref: ref,
    className: (0, _utils.clsNames)('un-list-grid', !props.justGrid && 'un-list', props.center && '-center', props.state && '-' + (0, _utils.stateColor)(props.state), props.className)
  }, props.children);
});
var _default = List;
exports.default = _default;
var ListStack = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement("div", {
    ref: ref,
    className: (0, _utils.clsNames)('un-list-stack', props.state && '-' + (0, _utils.stateColor)(props.state), props.className)
  }, props.children);
});
exports.ListStack = ListStack;
function ListContainer(props) {
  return /*#__PURE__*/React.createElement("div", {
    className: (0, _utils.clsNames)('un-list-container', props.className, props.scroll && '-scroll_container', props.fill && '-fill'),
    style: props.height ? {
      height: props.height
    } : undefined
  }, props.wait && /*#__PURE__*/React.createElement(_Wait.default, null), props.scroll ? /*#__PURE__*/React.createElement(_PageScroll.default, {
    className: props.classScroll
  }, props.children) : props.children);
}
function ListHead(props) {
  return /*#__PURE__*/React.createElement("div", {
    className: (0, _utils.clsNames)('un-list-head un-list-grid', props.className)
  }, props.children);
}
function ListHeadSort(props) {
  var sort = props.sort,
    current = props.current,
    firstDesc = props.firstDesc;
  var _useMemo = (0, React.useMemo)(function () {
      var currentx = current.split(':');
      var active = currentx[0] === sort;
      var direction = currentx.length > 1 && currentx[1] === 'desc' ? 'desc' : 'asc';
      return {
        active: active,
        direction: direction
      };
    }, [current]),
    active = _useMemo.active,
    direction = _useMemo.direction;
  return /*#__PURE__*/React.createElement("div", {
    className: (0, _utils.clsNames)('un-list-head-sort', props.className, active && '-active', active && '-' + direction),
    onClick: function onClick() {
      return props.onClick(sort + ((active || firstDesc) && direction !== 'desc' ? ':desc' : ''));
    }
  }, props.children);
}
function ListBody(props) {
  return /*#__PURE__*/React.createElement("div", {
    className: (0, _utils.clsNames)('un-list-body', props.className, props.scroll && '-scroll_container')
  }, props.wait && /*#__PURE__*/React.createElement(_Wait.default, null), props.scroll ? /*#__PURE__*/React.createElement(_PageScroll.default, {
    className: props.classScroll
  }, props.children) : props.children);
}
function ListFoot(props) {
  return /*#__PURE__*/React.createElement("div", {
    className: (0, _utils.clsNames)('un-list-foot un-list-grid', props.center && '-center', props.className)
  }, props.children);
}
function ListButton(props) {
  var mouseRef = (0, React.useRef)(0);
  var onMouseDown = function onMouseDown() {
    mouseRef.current = 1;
  };
  var onMouseMove = function onMouseMove() {
    if (mouseRef.current === 1) {
      setTimeout(function () {
        mouseRef.current = 2;
      }, 200);
    }
  };
  var onMouseUp = function onMouseUp(e) {
    if (mouseRef.current === 1 && !props.disabled && props.onClick) props.onClick(e);
    mouseRef.current = 0;
  };
  var onScroll = function onScroll(e) {
    e.preventDefault();
  };
  if (props.disabled) {
    if (typeof props.children === 'string') return /*#__PURE__*/React.createElement("div", null, props.children);
    return props.children;
  }
  if (props.href !== undefined) {
    var linkProp = {
      href: props.href,
      className: (0, _utils.clsNames)('un-list-button un-list-grid -link', props.className, props.fill && 'w-fill')
    };
    if (props.targetBlank) {
      linkProp.target = '_blank';
      linkProp.rel = 'noopener noreferrer';
    }
    if (props.download) {
      linkProp.download = true;
    }
    return /*#__PURE__*/React.createElement("a", linkProp, typeof props.children === 'string' ? /*#__PURE__*/React.createElement("span", null, props.children) : props.children);
  }
  return /*#__PURE__*/React.createElement("div", {
    className: (0, _utils.clsNames)('un-list-button un-list-grid', props.className, props.fill && 'w-fill'),
    onMouseDown: onMouseDown,
    onMouseMove: onMouseMove,
    onMouseUp: onMouseUp,
    onScroll: onScroll
  }, typeof props.children === 'string' ? /*#__PURE__*/React.createElement("div", null, props.children) : props.children);
}